import clientsApi from "@api/clients" //eslint-disable-line
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        loading: {
            clientList: false,
        },
        errors: {
            clientList: null,
        },
        clientList: [],
        client: [],
    },
    getters: {
        clientList: state => state.clientList,
        client: ({ client }) => client,
        getLoadingState: state => name => state.loading[name],
        getErrorState: state => name => state.errors[name],
    },
    mutations: {
        setError(state, error) {
            Vue.set(state.errors, error.name, error.value)
        },
        setLoadingState(state, loading) {
            Vue.set(state.loading, loading.name, loading.value)
        },
        setClientList(state, clients) {
            Vue.set(state, 'clientList', clients)
        },
        setClient(state, data) {
            const client = { ...data }
            Vue.set(state, 'client', client)
        },
    },
    actions: {
        setClientList({ commit }) {
            commit('setLoadingState', { name: 'clientList', value: true })

            return clientsApi
                .getClients()
                .then(response => {
                    const { data } = response.data

                    commit('setClientList', data)
                })
                .catch(() => {
                    commit('setError', {
                        name: 'clientList',
                        value: true,
                    })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'clientList', value: false })
                })
        },
        getClient({ commit }, { uuid, params }) {
            commit('setLoadingState', { name: 'client', value: true })

            return clientsApi
                .getClient(uuid, params)
                .then(response => {
                    const { data } = response.data
                    commit('setClient', data)
                })
                .catch(() => {
                    commit('setError', { name: 'client', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'client', value: false })
                })
        },
        setClient({ commit }) {
            commit('setClient', [])
        },
        clearError({ commit }, name) {
            commit('setError', {
                name,
                value: null,
            })
        },
        initializeClientManager({ dispatch }) {
            dispatch('setClientList')
        },
    },
}
